import {inject, injectable} from 'inversify'
import {CompanyInfoByInn, CompanyInfoServiceInterface} from '@/src/ports/services'
import type {IErrorReporter} from '@/src/ports/services/monitoring'
import {IErrorReporterSymbol} from '@/src/ports/services/monitoring'
import type {IApiClientServiceFactory} from '@/src/ports/services/api'
import {IApiClientServiceFactorySymbol} from '@/src/ports/services/api'
import {Routes} from '@/src/config/routes'

@injectable()
export class CompanyInfoService implements CompanyInfoServiceInterface {
  constructor(
    @inject(IErrorReporterSymbol) private errorReporter: IErrorReporter,
    @inject(IApiClientServiceFactorySymbol) private apiClientFactory: IApiClientServiceFactory,
  ) {}

  async getByInn(inn: string): Promise<CompanyInfoByInn[]> {
    const errorMessage = 'Не удалось получить информацию о компании'

    try {
      const client = this.apiClientFactory()
      return await client.get<CompanyInfoByInn[]>(Routes.api.order.companyInfo, {
        params: {inn},
      })
    } catch (e: unknown) {
      this.errorReporter.capture(`${errorMessage}: ${e}`)
      console.error(`${errorMessage}: ${e}`)
      throw Error('Что-то пошло не так, пожалуйста попробуйте позже')
    }
  }
}
